import styled from "styled-components";

import { Heading } from "@braze/beacon-core";

export const StyledHeading = styled(Heading)`
  text-align: center;
`;
